import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from 'components/layouts/InfoLayout';

const SpecialCredits = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'SpecialCredit.path',
          defaultMessage: 'SPECIAL_CREDIT.md',
        })}
        escapeHtml={false}
      />
    </InfoLayout>
  );
};

export default SpecialCredits;
